import { styled } from 'styletron-react';
import style from '../../style';

export default styled('i', ({ $error }) => ({
  padding: '0.2rem',
  fontSize: '0.8rem',
  color: $error ? style.red : 'initial',
}));
